import { Injectable } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BureauFeature, EmployeeHubFeature, HolidayApprovalsSection, PayrollSettingsSection, PayrollsFeature } from './app-features';
import { PayrollFeatureRouteData } from './cintra-payroll-routing.module';

@Injectable({
  providedIn: 'root'
})
export class ActiveFeatureService {
  activeFeature$ = new BehaviorSubject<PayrollsFeature | EmployeeHubFeature | BureauFeature>(undefined);
  activeSection$ = new BehaviorSubject<PayrollSettingsSection | HolidayApprovalsSection>(undefined);

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        const featureData = event.snapshot.data as PayrollFeatureRouteData;
        if (featureData.feature && this.activeFeature$.value !== featureData.feature) {
          this.activeFeature$.next(featureData.feature);
          this.activeSection$.next(featureData.section);
        }
      }
    });
  }
}
